import React, { useState } from "react";
import "../assets/styles/board.css";
import { Alert } from "react-bootstrap";

function Board({ clickedGrid, handleClick }) {
  const [showAlert, setShowAlert] = useState(false);

  
  const handleDismiss = () => setShowAlert(false);

  return (
    <div className="board-tictactoe">
      {clickedGrid.map((item, index) => {
        if (item === "") {
          return (
            <div
              key={index}
              className="square-tictactoe"
              onClick={() => handleClick(index)}
            >
              {item}{" "}
            </div>
          );
        } else {
          return (
            <div
              key={index}
              className="square-tictactoe"
              onClick={() => {
                return (
                  <Alert
                    show={showAlert}
                    variant="danger"
                    onClose={handleDismiss}
                    dismissible
                  >
                    Choose unoccupied cell!
                  </Alert>
                );
              }}
            >
              {item}
            </div>
          );
        }
      })}
    </div>
  );
}
export default Board;
